import styled from 'styled-components';

import {
  Modal as SemanticModal,
  Input as SemanticInput,
} from 'semantic-ui-react';

import { Button as ButtonComponent, Header as HeaderComponent, Text as TextComponent } from '@playbookux/playbook-web-core';

export const Modal = styled(SemanticModal)`
  &.ui.modal {
    padding: 20px;
    width: 530px;
    display: block;
    flex-direction: column;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
`;

export const InputContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 20px;
`;

export const Input = styled(SemanticInput)`
  width: 150px;
`;

export const StripeContainer = styled.div`
  margin-bottom: 20px;
`;

export const Header = styled(HeaderComponent)``;

export const Button = styled(ButtonComponent)`
  align-self: flex-end;
`;

export const Text = styled(TextComponent)`
  ${(props) => (props.withContainer ? `
    flex: 1;
  ` : `
    margin-bottom: 10px;
  `)}
  ${(props) => (props.noMargin && (`
    margin-bottom: 0;
  `))}
`;

export const ContainerInputError = styled.div``;

export const ErrorMsg = styled(TextComponent.Error)`
  position: fixed;
`;
